module.exports = __webpack_public_path__ + "static/green-foam-calentador-e5e955806d6267c26534f42b46102a27.png";